// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-pages-404-js": () => import("/opt/www/Gatsby_jbelknap.me/src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-about-js": () => import("/opt/www/Gatsby_jbelknap.me/src/pages/about.js" /* webpackChunkName: "component---src-pages-about-js" */),
  "component---src-pages-index-js": () => import("/opt/www/Gatsby_jbelknap.me/src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */)
}

